export default "__VITE_ASSET__B9uKH_lS__"